import React, { useState } from "react";
import { Card, CardBody, CardTitle, Button } from "reactstrap";
import Config from "config";
import { ToastContainer } from "react-toastify";

const OrganisationCard = ({ title, data, onSuccess, onError }) => {
  const [editing, setEditing] = useState(false);
  const [editedData, setEditedData] = useState({ ...data });
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);

  const handleEditClick = () => {
    setEditing(true);
  };

  const handleCancelClick = () => {
    setEditing(false);
    setEditedData({ ...data });
  };

  const handleChange = (e, key) => {
    setEditedData({
      ...editedData,
      [key]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_paiements/update_donnees_organisation`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            nom: editedData.Nom,
            adresse: editedData.Adresse,
            code_postal: editedData?.["Code postal"],
            ville: editedData.Ville,
            pays: editedData?.Pays,
            telephone_client: editedData?.["Téléphone"],
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        onSuccess();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();
        onError();
      }
    } catch (error) {
      console.error("An error occurred", error);
      console.error("Une erreur s'est produite");
    }
    console.log("Données modifiées :", editedData);
    setEditing(false);
  };

  return (
    <>
      <ToastContainer />
      <CardTitle className="h5" style={{ color: "#555b21" }}>
        {title}
      </CardTitle>
      <Card className="shadow-sm">
        <CardBody>
          <div className="d-flex flex-column mb-2">
            <dl className="row mb-0">
              {Object.entries(editedData).map(([key, value], index) => (
                <React.Fragment key={index}>
                  <dt className="col-sm-3 font-weight-bold">{key} :</dt>
                  <dd className="col-sm-9">
                    {editing ? (
                      <input
                        type="text"
                        className="form-control"
                        value={value}
                        onChange={(e) => handleChange(e, key)}
                      />
                    ) : (
                      <span>{value}</span>
                    )}
                  </dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
          <div className="d-flex justify-content-end">
            {editing ? (
              <>
                <Button
                  color="secondary"
                  size="sm"
                  className="mr-2"
                  onClick={handleCancelClick}
                >
                  Annuler
                </Button>
                <Button color="primary" size="sm" onClick={handleSubmit}>
                  Enregistrer
                </Button>
              </>
            ) : (
              <Button color="primary" size="sm" onClick={handleEditClick}>
                Modifier
              </Button>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default OrganisationCard;
